import { useFormContext } from 'react-hook-form'
import { toNumber } from 'lodash-es'
import { Divider, Stack } from '@mui/material'
import { TextField } from '@ui/forms'

interface Props {
  selectedTargetIndex: number
  disableChanging: boolean
}

export const ConnectionDetailsEdit = ({ selectedTargetIndex, disableChanging }: Props) => {
  const transmissionFactorPath = `verticalTransmissionGraph.element_targets.${selectedTargetIndex}.transmission_factor`

  const { setValue } = useFormContext()

  const handleChangeTransmissionFactor = (value: string) => {
    setValue(transmissionFactorPath, toNumber(value), {
      shouldDirty: true,
      shouldTouch: true,
    })
  }

  return (
    <>
      {!disableChanging && (
        <Stack spacing={1}>
          <Divider>Verbindung bearbeiten</Divider>
          <TextField
            inputLabel="Kraftfaktor"
            name={transmissionFactorPath}
            onChange={ev => handleChangeTransmissionFactor(ev.target.value)}
            type="number"
            size="small"
            inputProps={{
              step: 0.05,
              min: 0,
            }}
          />
        </Stack>
      )}
    </>
  )
}
